<template lang="pug">
.session-dates(v-if="enabled")
    .prev(v-if="showPrev" @click="prev"): i.icon-chevron-left
    .dates-viewport(ref="viewport")
        .dates(ref="dates")
            button.btn.date(
                type="button"
                v-for="[dateStr, localizedDate] of Object.entries(this.localizedDates)"
                :class="{ 'btn-primary': currentDate === dateStr}"
                @click="currentDate = dateStr")
                | {{ localizedDate }}
    .next(v-if="showNext" @click="next"): i.icon-chevron-right
</template>
<script>
import moment from 'moment-timezone';

// Constants
const SCROLL_STEP = 80;

export default {
    name: 'SessionDates',

    props: {
        sessions: {
            type: Array,
            required: true
        },

        eventTimezone: {
            type: String,
            required: true
        },

        useEventTimezone: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            currentDate: null,
            dates: new Map(),
            showPrev: false,
            showNext: false,
            scrollLeft: 0,
            scrollListener: null,
            tz: this.useEventTimezone ? this.eventTimezone : Intl.DateTimeFormat().resolvedOptions().timeZone
        };
    },

    computed: {
        viewportWidth() {
            return this.$refs.viewport ? Math.round(this.$refs.viewport.getBoundingClientRect().width) : 0;
        },

        datesWidth() {
            return this.$refs.dates ? Math.round(this.$refs.dates.getBoundingClientRect().width) : 0;
        },

        diff() {
            return Math.round(this.datesWidth - this.viewportWidth);
        },

        enabled() {
            return this.dates.size > 1;
        },

        localizedDates() {
            const localized = {};
            for(const [dateStr, date] of this.dates.entries()) {
                localized[dateStr] = date.toLocaleString(this.$i18n.locale, { month: 'short', day: 'numeric', timeZone: this.tz });
            }
            return localized;
        }
    },

    watch: {
        currentDate() {
            this.$emit('change', this.currentDate);
        },

        scrollLeft() {
            this.calculateScrollersVisibility();
        }
    },

    created() {
        for (const session of this.sessions) {
            this.dates.set(session.dates.startDateStr, session.dates.startDate);
        }

        const currentDay = moment().tz(this.tz).format('YYYY-MM-DD');

        for (const date of this.dates.keys()) {
            if (date === currentDay) {
                this.currentDate = date;
                break;
            } else if (!this.currentDate) {
                this.currentDate = date;
            }
        }
    },

    mounted() {
        if (this.enabled) {
            this.calculateScrollersVisibility();
            this.scrollListener = () =>  this.scrollLeft = this.$refs.viewport.scrollLeft;
            this.$refs.viewport.addEventListener('scroll', this.scrollListener);
        }
    },

    beforeDestroy() {
        if (this.enabled) {
            this.$refs.viewport.removeEventListener('scroll', this.scrollListener);
        }
    },

    methods: {
        calculateScrollersVisibility() {
            if (this.datesWidth <= this.viewportWidth) return;

            this.showPrev = this.scrollLeft !== 0;
            this.showNext = this.diff > this.scrollLeft;
        },

        prev() {
            this.scroll(SCROLL_STEP * -1);
        },

        next() {
            this.scroll(SCROLL_STEP);
        },

        scroll(amount) {
            this.$refs.viewport.scroll({
                top: 0,
                left: this.scrollLeft + amount,
                behavior: 'smooth'
            });
        }
    }
};
</script>
